"use strict";
const { MESSAGE_TYPES: { SMS, EMAIL }, } = require('../../constants');
exports.generateSmsMessage = ({ content }) => ({
    content,
    type: SMS,
});
exports.generateEmailMessage = ({ content }) => ({
    content,
    type: EMAIL,
});
//# sourceMappingURL=messageFactory.js.map